function ElementPickerMenuItem({ id, type, icon, title, setVisible, handleToolbarElements }) {
  const handleMouseDown = (e) => {
    setVisible(false);
    handleToolbarElements(e, type);
  };

  return (
    <li
      key={id}
      id={id}
      tabIndex={-1}
      className="li-item"
      onMouseDown={handleMouseDown}
      onClick={(e) => e.preventDefault()}>
      {icon}
      <span className="text">{title}</span>
    </li>
  );
}

export default ElementPickerMenuItem;
